import { useEffect } from 'react';
import { useFormik } from 'formik';
import { isEmpty } from 'lodash';
import {
  useNowEstablishPageTypeStore,
  useEstablishStore,
  getBtnProps,
  TransitionBtn,
  reloadHandler,
} from 'views/components/pages/accountEstablishment/hooks';
import {
  EstablishPageType,
  consentSecuritiesInitialValues,
  consentSecuritiesOnSubmit,
  ConsentSecuritiesFormikType,
  consentSecuritiesValidation,
  formErrorScroll,
  scrollToTop,
} from 'views/utils/accountEstablish';
import { ButtonProps } from 'views/components/atoms/button';
import { useNavigate } from 'react-router-dom';
import { AgreementDocumentInfo, useGetAgreementDocumentListQuery } from 'views/utils/graphql/graphql';

export const useConsentSecurities = () => {
  const navigate = useNavigate();
  const { nowEstablishPageType, setNowEstablishPageType } = useNowEstablishPageTypeStore();

  const { param, add } = useEstablishStore();
  const initialValues = consentSecuritiesInitialValues(param);
  const onSubmit = consentSecuritiesOnSubmit(param, setNowEstablishPageType, add);

  const [agreementDocuments, getAgreementDocuments] = useGetAgreementDocumentListQuery({
    variables: {},
    requestPolicy: 'network-only',
    pause: true,
  });

  const formik: ConsentSecuritiesFormikType = useFormik({
    initialValues,
    validationSchema: consentSecuritiesValidation,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit,
  });

  const nextButtonProps: ButtonProps = getBtnProps(TransitionBtn.NEXT);
  const prevButtonProps: ButtonProps = getBtnProps(TransitionBtn.PREV, () =>
    setNowEstablishPageType(EstablishPageType.AddvanceQuestion),
  );

  useEffect(() => {
    scrollToTop();
    window.addEventListener('beforeunload', reloadHandler);
    return () => {
      window.removeEventListener('beforeunload', reloadHandler);
    };
  }, []);

  useEffect(() => {
    if (nowEstablishPageType === EstablishPageType.ConsentSecurities) return;
    navigate(nowEstablishPageType.toString());
  }, [nowEstablishPageType]);

  useEffect(() => {
    if (isEmpty(formik.errors)) return;
    formErrorScroll();
  }, [formik.isSubmitting]);

  useEffect(() => {
    getAgreementDocuments();
  }, []);

  return {
    formik,
    buttonProps: {
      nextButtonProps,
      prevButtonProps,
    },
    agreementDocuments: (agreementDocuments.data?.GetAgreementDocumentList?.Data as AgreementDocumentInfo[]) ?? [],
  };
};
